<template>
  <iColumn gap="standard" width="fill">
    <iSubHeading>
      Revenue by payment method
    </iSubHeading>
    <iText variant="subtle" font-size="small">
      App Store and Google Play sales are shown after the store's fee. You receive what's left after your platform commission.
    </iText>
    <iDataTable
      :fields="fields"
      :items="rows"
      primary-key="method"
      :has-more="false"
      hide-actions
    >
      <template #td="{data, value}">
        <iText :font-weight="data.isTotal ? 'dark' : 'standard'">
          {{ value }}
        </iText>
      </template>
    </iDataTable>
  </iColumn>
</template>

<script>
const PROVIDER_LABELS = {
  apple: "App Store",
  google: "Google Play",
};

function formatCents(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

function toRow(method, totals, isTotal = false) {
  return {
    method,
    sales: totals.sales,
    gross: formatCents(totals.gross_cents),
    fee: formatCents(totals.fee_cents),
    net: formatCents(totals.net_cents),
    isTotal,
  };
}

// Card vs store split of a publication's subscription sales; all amounts arrive in cents.
export default {
  name: "RevenueByPaymentMethod",
  props: {
    revenue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: "method", label: "Payment method" },
        { key: "sales", label: "Sales" },
        { key: "gross", label: "Members paid" },
        { key: "fee", label: "Payment fees" },
        { key: "net", label: "You receive" },
      ],
    };
  },
  computed: {
    rows() {
      const storeRows = this.revenue.store.providers.map(provider => toRow(PROVIDER_LABELS[provider.provider], provider));
      const rows = [toRow("Card", this.revenue.card), ...storeRows];
      if (storeRows.length > 1) {
        rows.push(toRow("All app stores", this.revenue.store, true));
      }
      rows.push(toRow("Total", {
        sales: this.revenue.card.sales + this.revenue.store.sales,
        gross_cents: this.revenue.card.gross_cents + this.revenue.store.gross_cents,
        fee_cents: this.revenue.card.fee_cents + this.revenue.store.fee_cents,
        net_cents: this.revenue.total_net_cents,
      }, true));
      return rows;
    },
  },
};
</script>
